
/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

import axios from '../../../utils/axios';
import { dispatch } from '../../index';
import { handleError, handleSuccess, } from '../../../utils/apiResponseHandler.js';

const initialState = {
    error: null,
    complianceData: null,
    loading: false,
    verifyingApplication: false,

    totalPages: null,
    totalCount: null,
};

const slice = createSlice({
    name: 'adminCompliance',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        isLoading(state, action) {
            state.loading = action.payload;
        },

        isVerifyingApplication(state, action) {
            state.verifyingApplication = action.payload;
        },

        setComplianceDataSuccess(state, action) {
            state.complianceData = action.payload?.data;
            state.totalCount = action.payload?.totalCount;
            state.totalPages = action.payload?.totalPages;
        },

        updateComplianceDataSuccess(state, action) {
            const updatedComplianceData = state.complianceData.map((cmpData) => {
                if (cmpData?._id === action.payload?.id) {
                    return { ...cmpData, ...action.payload.data };
                }
                else {
                    return cmpData;
                }
            });
            state.complianceData = updatedComplianceData;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getAllComplianceData({ page, limit, search }) {
    return async () => {
        try {
            dispatch(slice.actions.isLoading(true))

            const response = await axios.get(`/admin/compliance?search=${search}&page=${page}&limit=${limit}`);
            dispatch(slice.actions.setComplianceDataSuccess(response?.data))

            return response?.data?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isLoading(false))
        }
    }
}

export function verifyComplianceApplication({ cmpId, data }) {
    return async () => {
        try {
            console.log("cmpID", "data", cmpId, data);

            dispatch(slice.actions.isVerifyingApplication(true))

            const response = await axios.patch(`/admin/compliance/verify-status/${cmpId}`, data);
            dispatch(slice.actions.updateComplianceDataSuccess({ id: cmpId, data: response.data?.data }))

            handleSuccess(response, "Status updated successfully", dispatch);

            return response?.data;
        }
        catch (err) {
            handleError(err, dispatch);
        }
        finally {
            dispatch(slice.actions.isVerifyingApplication(false))
        }
    }
}
